import React, { Component } from 'react'
import { MemberLinkBtn } from '../../styles/Elements';
import '../../css/BisharatMain.css';
import MemberDataService from '../../services/MemberDataService';

import {
    MdDelete, MdBuild, MdZoomIn, MdChildCare, MdGroup, MdPerson, MdSearch
} from "react-icons/md";



export default class ChildrenDetail extends Component {
    state = {
        children: [],
        selectedMemberHasChildren: false,
    }

    componentDidMount() {
        this.refreshChildren();

    }


    refreshChildren = () => {
        const { match: { params } } = this.props;
        const id = params.id;
      
        MemberDataService.getChildren(id)
            .then(res => {
                const children = res.data;
                this.setState({ children });
            })
    }



    deleteMemberClicked(childId) {
        MemberDataService.deleteMember(childId)
            .then((response) => {
                this.refreshChildren();
            })
            .catch((err) => {
            });
    }
 
    
    
    gotoMemberEdit(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/edit`;
        }


    }




    showMember(member) {
        this.setState({ selectedMember: member })
        this.setState({ showMemberClicked: true })
        if(member.children.length > 0) {
            this.setState({selectedMemberHasChildren : true})
        } else {
            this.setState({selectedMemberHasChildren : false}) 
        }
    }

    gotoMemberProfile(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}`;
        }

    }


    gotoUpalodProfilePicture(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/profile/${id}`;
        }

    }

    // gotoPartnerProfile(id) {
    //     if (id === undefined) {
    //         alert("Please Select Member !");
    //     } else {
    //         window.location.href = `/family-members/partner/${id}`;
    //     }
    // }


    gotoChildrenList(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/children`;
        }
    }


    goToCreateChild(id) {
        if (id === undefined) {
            alert("Please Select Member !");
        } else {
            window.location.href = `/family-members/${id}/childcreate`;
        }
    }



    render() {
       const parentId = this.props.match.params.id;
        return (
            <div className="top-level-page-main family-children">
                <div className="container-view-contents family-children">
                    <div className="list-wrap-contents family-children">
                        <div className="top-actions family-children">

                    
                             <button className="btn" onClick={this.props.history.goBack}> رجوع  </button>
                            <MemberLinkBtn to={`/family-members/${parentId}/childcreate`}> اضافة طفل  </MemberLinkBtn>
                            <input type="text" name="searchfield" placeholder="ابحث "
                            // value={this.state.fatherName}
                            // onChange={this.onChange}
                            />
                            <MdSearch size={40} color="#538D22" />
                        </div>
                        <div className="list-of-contents">
                            {this.state.children.map(child => (
                                <div className="one-of-list" key={child.id}>
                                    <h4
                                        onMouseOver={({ target }) => target.style.color = 'red'}
                                        onMouseOut={({ target }) => target.style.color = '#538D22'}
                                        onClick={() => this.showMember(child)}
                                    >{child.name}  {child.fatherName}  بشارات</h4>
                                </div>

                            ))}
                        </div>
                        {this.state.showMemberClicked ?

                            <div className="set-of-icons">

                                <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = 'red'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                >
                                    <MdDelete
                                        onClick={() => { if (window.confirm('Are you sure you want to delete this member?')) this.deleteMemberClicked(this.state.selectedMember.id) }} size={20} color="#538D22" />
                                    <p >حذف</p>
                                </div>

                                <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = '#AAD576'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                    onClick={() => this.gotoMemberEdit(this.state.selectedMember.id)}
                                >
                                    <MdBuild size={20} color="#538D22" />
                                    <p>تعديل</p>
                                </div>

                                <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = 'red'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                    onClick={() => this.gotoMemberProfile(this.state.selectedMember.id)}
                                >
                                    <MdZoomIn size={20} color="#538D22" />
                                    <p>ملف كامل</p>
                                </div>
                                <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = 'red'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                    onClick={() => this.gotoUpalodProfilePicture(this.state.selectedMember.id)}
                                >
                                    <MdPerson size={20} color="#538D22" />
                                    <p>صوره بروفايل </p>
                                </div>


                                {this.state.selectedMemberHasChildren  ?
                                <>
                                    <div className="one-action"
                                        onMouseOver={({ target }) => target.style.color = 'red'}
                                        onMouseOut={({ target }) => target.style.color = '#538D22'}
                                        onClick={() => this.gotoChildrenList(this.state.selectedMember.id)}

                                    >
                                        <MdChildCare size={20} color="#538D22" />
                                        <p>الاطفال</p>
                                    </div>
                
                                </> : <div className="one-action"
                                    onMouseOver={({ target }) => target.style.color = 'red'}
                                    onMouseOut={({ target }) => target.style.color = '#538D22'}
                                    onClick={() => this.goToCreateChild(this.state.selectedMember.id)}
                                >
                                    <MdGroup size={20} color="#538D22" />
                                    <p>اضافة طفل </p>
                                </div>
                            }

                        </div> : <div className="set-of-icons"><h4> اختار من القائمة </h4></div> }
                    </div>


                    {this.state.showMemberClicked ?
                        <div className="details">

                            <div className="card-details">

                                <div className="card-group-field">

                                    <h4> ID </h4>
                                    <h4> {this.state.selectedMember.id}</h4>
                                </div>

                                <div className="card-group-field">
                                    <h4>  :الاسم    </h4>
                                    <h4> {this.state.selectedMember.name}   </h4>
                                </div>

                                <div className="card-group-field">
                                    <h4>   :اسم الأب    </h4>
                                    <h4> {this.state.selectedMember.fatherName ? this.state.selectedMember.fatherName : <p>غير موجود</p>}   </h4>
                                </div>

                                <div className="card-group-field">
                                    <h4>  :اسم الأم     </h4>
                                    <h4> {(this.state.selectedMember.motherName) ? this.state.selectedMember.motherName : <p>غير موجود</p>}   </h4>
                                </div>

                                <div className="card-group-field">
                                    <h4> :رقم الهاتف </h4>
                                    <h4> {this.state.selectedMember.phoneNumber ? this.state.selectedMember.phoneNumber : <p>غير موجود</p>}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4>  :العنوان </h4>
                                    <h4> {this.state.selectedMember.address ? this.state.selectedMember.address : <p>غير موجود</p>}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4> :رقم الهويّة  </h4>
                                    <h4> {this.state.selectedMember.identity ? this.state.selectedMember.identity : <p>غير موجود</p>}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4> :تاريخ الميلاد  </h4>
                                    <h4> {(this.state.selectedMember.birthdate) ? this.state.selectedMember.birthdate : <p>غير موجود</p>}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4> :الجنس   </h4>
                                    <h4> {this.state.selectedMember.gender ? this.state.selectedMember.gender : <p>غير موجود</p>}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4> :الحالة الاجتماعيّة   </h4>
                                    <h4> {(this.state.selectedMember.isMarried === 'yes') ? "متزوج" : "اعزب"}   </h4>
                                </div>
                                <div className="card-group-field">
                                    <h4> على قيد الحياة؟</h4>
                                    <h4> {this.state.selectedMember.isAlive ? this.state.selectedMember.isAlive : <p>غير موجود</p>}   </h4>
                                </div>

                            </div>
                        </div> : <div></div>}
                </div>
            </div>

        )
    }
}
